import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';

class ChangeAddress extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true,
            addressChanged: false, 
            CustomerAddresses: ''
        };
    }

    fetchCustomerAddress(mode,id,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/customeraddress_api.php?mode='+mode+'&id='+id+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let customer_addresses = result.addresses;
            if(customer_addresses=='' || customer_addresses==undefined)
                customer_addresses = '';

            that.setState({ LOADING:false, CustomerAddresses:customer_addresses });
        });
    }

    handleAddressChanged = () => {

        let address_id = '';
        $.each($("input[name='address']:checked"), function(){            
            address_id = $(this).val();
        });
        localStorage.setItem('addressID', address_id);

        this.setState({ addressChanged:true });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        let customer = '';

        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');

        let circle_id = localStorage.getItem('delCIRCLE');
        console.log(circle_id);
        this.fetchCustomerAddress('ADDRESS',circle_id,customer);
    }

    render() { 

        //localStorage.removeItem("userData");
        //localStorage.removeItem("cartData");
        //localStorage.removeItem("delCity");
        //localStorage.removeItem("delArea");
        //console.log(localStorage.getItem('userData'));

        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';

        if (logged=='N')
        {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
                return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        if(this.state.addressChanged)
        {
            return (<Redirect to={'/checkout'}/>)
        }

        let address_id = '';
        if(localStorage.getItem('addressID')!=null)
            address_id = localStorage.getItem('addressID');

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/checkout';
        let AppHeaderTitle = 'Delivery Address';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="delivery-location section full mt-0">
                        {this.state.CustomerAddresses.length>0 && this.state.CustomerAddresses.map(post => {
                            let checked = false;
                            if(address_id!='' && address_id==post.ID)
                                checked = true;
                            else
                            {
                                if(post.DEFAULT=='Y')
                                    checked = true;
                            }

                            return (
                                <div className="wide-block pt-2 pb-2" key={post.ID}>
                                    <div className="sumup">
                                        <div className="custom-control custom-radio">
                                            <input type="radio" id={`address_${post.ID}`} name="address" value={post.ID} className="custom-control-input" defaultChecked={checked} />
                                            <label className="custom-control-label" htmlFor={`address_${post.ID}`}>
                                                <h5 className="font-weg-400 mb-05">{post.CIRCLE}
                                                    <span className="badge chip-warning chip-outline ht-17 font-size-10  font-weg-500 text-upper ltsp">{post.LABEL}</span>
                                                </h5>
                                                <p className="font-size-13l font-weg-300 mb-05">{post.ADDRESS}</p>
                                                {post.MOBILE_NO && <div className="stateline pin">
                                                    <span className="text-lgrey font-size-12 mb-05 mr-1">{post.MOBILE_NO}</span>
                                                </div>}
                                            </label>
                                        </div>
                                    </div>
                                </div>                 
                            );
                        }) }
                    </div>
                    {this.state.CustomerAddresses.length==0 &&
                        <div className="form-button-group1 pr-2 pl-2">
                            <div className="col-12">
                                <div className="text-upper">
                                    <div className="row">
                                        <div className="col-12">
                                        <Link to="/addaddress" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">Add New Address</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.CustomerAddresses.length>0 &&
                        <div className="form-button-group1 pr-2 pl-2">
                            <div className="col-6">
                                <div className="text-upper">
                                    <div className="row">
                                        <div className="col-12">
                                            <Link to="/addaddress" className="btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block">Add Address</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="text-upper">
                                    <div className="row">
                                        <div className="col-12">
                                            <button type="button" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block" onClick={()=>{this.handleAddressChanged()}}> NEXT</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}
  
export default ChangeAddress;


// WEBPACK FOOTER //
// ./src/components/ChangeAddress.js